module.exports = __webpack_public_path__ + "static/kruticka2_orez-e9a07b67ee242b424627b236ae5f2051.png";